import store from "../redux/Store";
import {
    TAG_DISCOUNTS_CRUD_FORM_BATCH_EDIT,
    TAG_DISCOUNTS_CRUD_FORM_CANCEL,
    TAG_DISCOUNTS_DISPLAY_BAR,
    TAG_DISCOUNTS_CRUD_FORM_DONE
} from "./actions/TagDiscountEditorActions";
import { getDiscountsByTagId } from "../api/actions/DiscountActions";
import { $serializeForm } from "../main";
import {
    updateDiscountsByTagId,
    deleteDiscountsFromTags,
    putDiscountsToTags,
    deleteAllDiscountsFromTags
} from "../api/actions/DiscountActions";

export const dispatch_EnableTagDiscountBatchEditEvent = () => {
    store.dispatch(TAG_DISCOUNTS_CRUD_FORM_BATCH_EDIT({ discounts: [] }));
};
export const dispatch_DisableTagDiscountBatchEditEvent = () => {
    store.dispatch(TAG_DISCOUNTS_CRUD_FORM_CANCEL({ discounts: [] }));
};
export const dispatchDisableTagDiscountEdit_Event = () => {
    store.dispatch(TAG_DISCOUNTS_CRUD_FORM_CANCEL({ discounts: [] }));
};

export const updateDiscountsByTagId_Event = ({ detail: { payload: { form, id } } }) => {

    const [encoded, decoded] = $serializeForm(form.current);

    let payload = { id: decoded.id, discounts: decoded.discountSelected };

    updateDiscountsByTagId(decoded.id, payload)
        .then((result) => {
            console.log('updateDiscountsByVariantId.successful', result);
            store.dispatch(TAG_DISCOUNTS_CRUD_FORM_CANCEL(null));
        })
        .catch((error) => {
            console.error("updateDiscountsByVariantId.Error:", error);
        });
};

export const enableTagDiscountEdit_Event = ({ detail: { payload: tag } }) => {

    let tagDiscounts = { ...store.getState().ui.ui_tagDiscounts };

    if (typeof tagDiscounts != 'object') {
        tagDiscounts = {};
    }

    getDiscountsByTagId(tag.id)
        .then((result) => {
            //console.log();
            let discounts = result.content || [];
            if (Array.isArray(discounts) && discounts.length > 0) {
                discounts = discounts.map(discount => ({ id: discount.id, name: discount.name }));
            }
            console.log();
            store.dispatch(TAG_DISCOUNTS_CRUD_FORM_DONE({ ...tag, discounts: discounts }));
        }).catch((error) => {
            store.dispatch(TAG_DISCOUNTS_CRUD_FORM_DONE(null));
        });

    //dispatch(VARIANT_TAG_CRUD_FORM_BATCH_EDIT());
};
export const getDiscountsByTagId_Event = ({ detail: { payload: tag } }) => {

    let tagDiscounts = store.getState().ui.ui_tagDiscounts || {};

    let discounts = tagDiscounts[tag.id];

    if (discounts && discounts.visibility) {
        store.dispatch(TAG_DISCOUNTS_DISPLAY_BAR({
            ...tagDiscounts,
            [tag.id]: {
                discounts,
                visibility: !discounts.visibility
            }
        }));
        return;
    }

    getDiscountsByTagId(tag.id)
        .then((result) => {
            let discounts = result.content;
            if (Array.isArray(discounts) && discounts.length > 0) {
                discounts = discounts.map(discount => ({ id: discount.id, name: discount.name }));
            }
            console.log('getDiscountsByTagId', discounts);
            store.dispatch(TAG_DISCOUNTS_DISPLAY_BAR({
                ...tagDiscounts,
                [tag.id]: {
                    visibility: !!discounts,
                    data: { ...tag, discounts: discounts },
                    state: "DONE"
                }
            }));
        }).catch((error) => {
            store.dispatch(TAG_DISCOUNTS_DISPLAY_BAR({
                ...tagDiscounts,
                [tag.id]: {
                    visibility: false,
                    data: {},
                    state: "ERROR",
                    error: true
                }
            }));
        });
};

export const deleteDiscountsFromSelectedTags_Event = ({ detail: { payload: { list, input } } }) => {

    let [json, decoded] = $serializeForm(input.current.getForm());
    let discountSelected = decoded.discountSelected;
    let tags = Object.keys(list.current.getChecked());
    let payload = { tags: tags, discounts: discountSelected };

    deleteDiscountsFromTags(payload)
        .then((result) => {
            console.log('deleteDiscountsFromSelectedTags_Event', result.content);
        })
        .catch(error => {
            console.error('deleteDiscountsFromSelectedTags_Event', error);
        });

}

export const insertDiscountsToSelectedTags_Event = ({ detail: { payload: { list, input } } }) => {

    let [json, decoded] = $serializeForm(input.current.getForm());
    let discountSelected = decoded.discountSelected;
    let tags = Object.keys(list.current.getChecked());
    let payload = { tags: tags, discounts: discountSelected };

    putDiscountsToTags(payload)
        .then((result) => {
            console.log('insertDiscountsToSelectedTags_Event', result.content);
        })
        .catch(error => {
            console.error('insertDiscountsToSelectedTags_Event', error);
        });

}

export const selectAllTags_Event = ({ detail: { payload: { list } } }) => {

    let tags = store.getState().base.tags;

    let all = tags.reduce((accumulator, current) => {
        accumulator[current.id] = true;
        return accumulator;
    }, {})

    list.current.setChecked(all);
};

export const deselectTags_Event = ({ detail: { payload: { list } } }) => {
    list.current.setChecked([]);
};

export const deleteAllDiscountsFromSelectedTags_Event = ({ detail: { payload: { list } } }) => {

    let tags = Object.keys(list.current.getChecked());
    let payload = { ids: tags };

    deleteAllDiscountsFromTags(payload)
        .then((result) => {
            console.log('deleteAllDiscountsFromSelectedTags_Event', result.content);
        })
        .catch(error => {
            console.error('deleteAllDiscountsFromSelectedTags_Event', error);
        });

}